import { useFlags } from 'launchdarkly-react-client-sdk'

export type HomeVariation = '1b' | '2b' | '3b' | 'default'

const variations = ['1b', '2b', '3b', 'default'] as HomeVariation[]

const useFeatureVariation = (flagName: string, defaultVariation: HomeVariation = 'default'): HomeVariation => {
  const flags = useFlags()

  if (!flags || !flags[flagName]) {
    return defaultVariation
  }

  const variation = flags[flagName]

  if (variations.includes(variation)) {
    return variation
  }

  return defaultVariation
}

export default useFeatureVariation
